/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RegisterAccountRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {RegisterAccountResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const registerAccount = (request: RegisterAccountRequest, options?: CashRequestOptions) => post<RegisterAccountRequest, RegisterAccountResponse>("/cash-app/local/register-account", request, {...options, rejectOnError: true })